// extracted by mini-css-extract-plugin
module.exports = {"app":"RootLayout_app__N2C_F","app__main":"RootLayout_app__main__nC7JZ","app__main--empty":"RootLayout_app__main--empty__wV3vH"};